/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThresholdNotificationConfigurationModel {
    getFixupPrototypeFunction() { return ThresholdNotificationConfigurationModel.fixupPrototype; }

    static newInstance(model: Partial<ThresholdNotificationConfigurationModel>): ThresholdNotificationConfigurationModel {
        let obj = Object.assign(new ThresholdNotificationConfigurationModel(), model);
        ThresholdNotificationConfigurationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThresholdNotificationConfigurationModel>): ThresholdNotificationConfigurationModel {
        if (!model) return null;
        return ThresholdNotificationConfigurationModel.newInstance(<ThresholdNotificationConfigurationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThresholdNotificationConfigurationModel) {
        if (!obj) return;

        models.ThresholdNotificationConfigurationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThresholdNotificationConfigurationModel): boolean {
        Object.setPrototypeOf(obj, ThresholdNotificationConfigurationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.notification_configuration) {
            for (let val of this.notification_configuration) {
                models.NotificationConfigurationModel.fixupPrototype(val);
            }
        }
    }

    /**
     * notification configuration
     */
    notification_configuration: Array<models.NotificationConfigurationModel>;

    /**
     * notification uri
     */
    notification_uri: Array<string>;

}
